import { MIN_PUNCH_DISTANCE } from '../constants';

export const PUNCH_DISTANCE_ERROR_KEY =
  'positionTemplate.create.additionalInfo.error.punchDistance';

export const getPunchDistanceError = (info) => {
  if (!info?.isGPSEnforced) return null;

  const distance = String(info.punchDistance ?? '').trim();
  const isWholeNumber = /^\d+$/.test(distance);

  return isWholeNumber && Number(distance) >= MIN_PUNCH_DISTANCE ? null : PUNCH_DISTANCE_ERROR_KEY;
};
